<template>
  <div class="procurement-match-page">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>项目信息</span>
      </div>
      <div class="project-info-row">
        <p><strong>项目名称:</strong> {{ projectInfo.bid_title }}</p>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>外采需求详细列表</span>
      </div>
      <div v-if="loading" style="text-align: center; padding: 50px;">
        <i class="el-icon-loading"></i>
        <p>数据加载中...</p>
      </div>
      <el-table v-else :data="paginatedOutsourceList" style="width: 100%" border>
        <el-table-column prop="required_title" label="名称/标题" min-width="180"></el-table-column>
        <el-table-column prop="item_type" label="类型" width="80"></el-table-column>
        <el-table-column prop="required_author" label="作者" width="120"></el-table-column>
        <el-table-column prop="required_isbn" label="ISBN" width="150"></el-table-column>
        <el-table-column prop="required_edition" label="版本/要求" min-width="150"></el-table-column>
        <el-table-column prop="required_quantity" label="需求数量" width="100"></el-table-column>
        <el-table-column prop="status" label="匹配状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button @click="handleMatch(scope.row)" type="text" size="small">
              {{ scope.row.status === '未匹配' ? '进行匹配' : '查看/修改' }}
            </el-button>
            <el-button @click="handleDelete(scope.$index + (currentPage - 1) * pageSize)" type="text" size="small"
              style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="outsourceList.length">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="`外采匹配: ${currentMatchItem.required_title}`" :visible.sync="dialogVisible" width="60%">
      <div v-if="currentMatchItem.status === '已匹配' || currentMatchItem.status === '部分匹配'">
        <h4>已匹配详情</h4>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="匹配来源">{{ currentMatchItem.match_details.match_source_name }}</el-descriptions-item>
          <el-descriptions-item label="匹配书名/标题">{{ currentMatchItem.match_details.matched_title }}</el-descriptions-item>
          <el-descriptions-item label="匹配ISBN">{{ currentMatchItem.match_details.matched_isbn || '无' }}</el-descriptions-item>
          <el-descriptions-item label="单价">{{ currentMatchItem.match_details.matched_price_unit || '无' }} 元</el-descriptions-item>
          <el-descriptions-item label="匹配时间">{{ currentMatchItem.match_details.match_time | formatDate }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">
            <span v-if="currentMatchItem.notes">{{ currentMatchItem.notes }}</span>
            <span v-else>无</span>
          </el-descriptions-item>
        </el-descriptions>
        <el-divider></el-divider>
      </div>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="搜索匹配" name="search">
          <div style="margin-top: 10px;">
            <el-input placeholder="请输入书名或ISBN" v-model="searchKeyword" style="width: 400px;"></el-input>
            <el-button type="primary" style="margin-left: 10px;" @click="searchBooks">搜索</el-button>
          </div>
          <el-table :data="searchResults" style="width: 100%; margin-top: 20px;" border>
            <el-table-column prop="title" label="书名/标题"></el-table-column>
            <el-table-column prop="publisher" label="出版社/来源"></el-table-column>
            <el-table-column prop="isbn" label="ISBN"></el-table-column>
            <el-table-column prop="price" label="单价" width="80"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="selectMatch(scope.row)" type="text" size="small">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="手动录入" name="manual">
          <el-form :model="manualForm" ref="manualForm" label-width="120px" style="margin-top: 20px;">
            <el-form-item label="匹配书名">
              <el-input v-model="manualForm.bookName"></el-input>
            </el-form-item>
            <el-form-item label="来源供应商">
              <el-input v-model="manualForm.source"></el-input>
            </el-form-item>
            <el-form-item label="ISBN">
              <el-input v-model="manualForm.isbn"></el-input>
            </el-form-item>
            <el-form-item label="单价">
              <el-input v-model.number="manualForm.price"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align: right;">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveManualMatch">确 定</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
// 导入数据文件
import mockOutsourceList from '../../../src/dataJson/mockOutsourceList';

export default {
  data() {
    return {
      projectInfo: {
        "bid_id": "Tender-2025-Q3-LibProj-007",
        "bid_title": "2025年秋季市级重点图书馆采购项目",
        "client": "A市文化广电新闻出版局",
        "project_manager": "王强",
        "deadline": "2025-09-30T17:00:00Z",
        "budget_total": 5000000.00,
        "status": "进行中"
      },
      outsourceList: [],
      loading: true,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      currentMatchItem: {},
      activeTab: 'search',
      searchKeyword: '',
      searchResults: [],
      manualForm: {
        bookName: '',
        source: '',
        isbn: '',
        price: ''
      }
    };
  },
  computed: {
    paginatedOutsourceList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.outsourceList.slice(start, end);
    }
  },
  methods: {
    // 异步加载数据的方法
    loadData() {
        this.loading = true;
        // 模拟网络延迟
        setTimeout(() => {
            // 直接使用导入的数据
            this.outsourceList = mockOutsourceList;
            this.loading = false;
        }, 500); // 模拟500ms的加载时间
    },
    getStatusTagType(status) {
      const tagTypeMap = {
        '未匹配': 'info',
        '已匹配': 'success',
        '部分匹配': 'warning',
        '匹配失败': 'danger'
      };
      return tagTypeMap[status] || 'info';
    },
    handleMatch(item) {
      this.currentMatchItem = { ...item };
      this.dialogVisible = true;
      this.activeTab = 'search';
      this.searchKeyword = item.required_title;
      this.searchResults = [];
    },
    handleDelete(index) {
      this.$confirm('此操作将永久删除该条目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.outsourceList.splice(index, 1);
        this.$message.success('删除成功!');
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    searchBooks() {
      console.log('正在搜索:', this.searchKeyword);
      this.searchResults = [
        { id: 'ext-rand-01', title: `搜索结果：${this.searchKeyword}（版本1）`, publisher: '模拟出版社A', isbn: '978-7-999-11111-1', price: 55.00 },
        { id: 'ext-rand-02', title: `搜索结果：${this.searchKeyword}（版本2）`, publisher: '模拟出版社B', isbn: '978-7-999-22222-2', price: 62.50 },
        { id: 'ext-rand-03', title: `搜索结果：${this.searchKeyword}（版本3）`, publisher: '模拟出版社C', isbn: '978-7-999-33333-3', price: 48.00 },
      ];
    },
    selectMatch(matchedItem) {
      const index = this.outsourceList.findIndex(item => item.requirement_id === this.currentMatchItem.requirement_id);
      if (index !== -1) {
        this.outsourceList[index].status = '已匹配';
        this.outsourceList[index].match_details = {
          match_source_name: matchedItem.publisher,
          matched_title: matchedItem.title,
          matched_isbn: matchedItem.isbn,
          matched_price_unit: matchedItem.price,
          match_time: new Date().toISOString()
        };
      }
      this.dialogVisible = false;
      this.$message.success('匹配成功!');
    },
    saveManualMatch() {
      const index = this.outsourceList.findIndex(item => item.requirement_id === this.currentMatchItem.requirement_id);
      if (index !== -1) {
        this.outsourceList[index].status = '已匹配';
        this.outsourceList[index].match_details = {
          match_source_name: this.manualForm.source,
          matched_title: this.manualForm.bookName,
          matched_isbn: this.manualForm.isbn,
          matched_price_unit: this.manualForm.price,
          match_time: new Date().toISOString()
        };
      }
      this.dialogVisible = false;
      this.$message.success('手动录入成功!');
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return '';
      const date = new Date(value);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
  },
  // 在组件挂载后立即加载数据
  mounted() {
      this.loadData();
  }
};
</script>

<style scoped>
.procurement-match-page {
  padding: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.project-info-row p {
  line-height: 1.5;
  margin: 5px 0;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/externalprocurementmatching/index.vue